import { Component } from "~/src/internals/Component";

export class Activable extends Component {
  active = true;
}
